class ValidateTimeTracking extends ValidatePage {
    constructor(_parent) {
        super();
        this.parent = _parent;
        this.parent.inputs.forEach(input => {
            this.inputs.push(this.parent.define_elem(input));
        }); 
        this.parent.define_elem( this.parent.inputs[0] );
        this.debug = this.parent.debug.extends.ValidateTimeTracking; // Turn on debugger in ValidatePage
    }  

    async _validate(){
        const order_status = this.inputs.find(input => input.id === 'order_status').value;
        const shipping_alert = this.inputs.find(input => input.id === 'shipping_alert').value;

		if (order_status == "shipped" && shipping_alert != 1) {
            this.parent.failed_obj_push( { target: 'track_order', custom_section: 'track_order', msg: get_language_translation('LANG_ORDER_SHIPPED_ERROR') } ); 
		}
            
        if(this.debug)
            console.log(this, "ValidateTimeTracking - this");
        
        return;
    }
}

async function timeTrackingValidation(pv){
    var tt = new ValidateTimeTracking(pv);
        return await tt._validate();
} 